import { ChannelsSidePanel } from "#features/channels/components/ChannelsSidePanel.tsx";
import { SourcesSidePanel } from "#features/conversations/components/sources-side-panel/SourcesSidePanel.tsx";
import { useSidePanelStore } from "#stores/useSidePanelStore.ts";
import type { GridProps } from "@hopper-ui/components";
import "./SidePanel.css";

export const SidePanel = ({ ...rest }: Partial<GridProps>) => {
    const sidePanelType = useSidePanelStore(state => state.type);

    switch (sidePanelType) {
        case "sources":
            return <SourcesSidePanel {...rest} />;
        case "channels":
            return <ChannelsSidePanel {...rest} />;
        default:
            return null;
    }
};
